export default __webpack_public_path__ + "static/media/img (3).918efcb5.jpg";